import { client } from "@/shared/api/newsquawk-headlines";
import { Endpoints } from "./endpoints";
import { Headline, HeadlineTimestamp } from "../models/Headline";
import { isToday } from "@/utils/date-utils";

interface GroupedByDate {
  [date: string]: Headline[];
}

const getUnixTimestamp = (x: HeadlineTimestamp | string) =>
  typeof x === "string" ? Date.parse(x) : x.unix;

export const groupHeadlinesByDate = (data: Headline[]) => {
  const groups = [] as string[];

  // Headlines are already sorted by published_at (descending) from the cache
  // No need to sort here - trust the source order

  // Use reduce to group records by date
  const groupedByDate = data.reduce((acc: GroupedByDate, record: Headline) => {
    // Extract just the date part from the text timestamp (YYYY-MM-DD)

    let dateString;
    let publishedDate = null;

    if (typeof record.published_at === "string") {
      publishedDate = new Date(record.published_at);
    } else {
      publishedDate = new Date(record.published_at.unix * 1000);
    }

    if (isToday(publishedDate)) {
      dateString = "Today";
    } else {
      dateString = publishedDate.toLocaleDateString("en-US", {
        weekday: "short",
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    }

    // If this date doesn't exist in our accumulator yet, create an empty array
    if (!acc[dateString]) {
      acc[dateString] = [];
      groups.push(dateString);
    }

    // Add the current record to the appropriate date array
    acc[dateString].push(record);

    return acc;
  }, {});

  const groupedCounts = Object.keys(groupedByDate).map(
    (key) => groupedByDate[key].length
  );

  return {
    groups,
    groupedByDate,
    groupedCounts,
  };
};

export const deleteHeadline = async (id: number) => {
  await client.delete(`${Endpoints.DeleteHeadline}/${id}`);
};

export const getHeadlineById = async (id: number) => {
  const response = await client.get(`${Endpoints.GetHeadlineById}/${id}`);
  return response.data;
};
